import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import PageWrapper from "../../components/PageWrapper";


const BASE_URL = process.env.REACT_APP_BASE_URL;

const Blogs2 = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogDetail();
  }, [id]);

  const fetchBlogDetail = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/superadmin/blogs/${id}`);
      if (!res.ok) throw new Error("Failed to fetch blog");
      const data = await res.json();
      setBlog(data);
    } catch (err) {
      console.error("Error fetching blog:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <PageWrapper
        title="Blog Detail"
        subtitle="Read the complete blog post"
      >
        <Container className="py-5 text-center">
          <p>Loading blog...</p>
        </Container>
      </PageWrapper>
    );
  }

  if (!blog) {
    return (
      <PageWrapper
        title="Blog Not Found"
        subtitle="The blog you're looking for doesn't exist"
      >
        <Container className="py-5 text-center">
          <p>Blog not found.</p>
          <Button onClick={() => navigate("/blogs1")} className="btn-custom mt-3">
            Back to Blogs
          </Button>
        </Container>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper
      title={blog.title1 || "Blog Detail"}
      subtitle={blog.short_description || ""}
    >
      <section className="blog-content py-3 px-3">
        <Container>
          {/* Blog Header */}
          <Row className="mb-5">
            <Col lg={10} className="mx-auto">
              <div className="blog-header">
                {/* Title */}
                <h1 className="blog-detail-title">{blog.title1}</h1>

                {/* Meta Info */}
                <div className="blog-detail-meta mt-3">
                  {blog.published_date && (
                    <span className="meta-item">
                      <i className="fas fa-calendar"></i>
                      {new Date(blog.published_date).toLocaleDateString()}
                    </span>
                  )}
                  {blog.read_time && (
                    <span className="meta-item">
                      <i className="fas fa-clock"></i>
                      {blog.read_time}
                    </span>
                  )}
                  {blog.author_name && (
                    <span className="meta-item">
                      <i className="fas fa-user"></i>
                      {blog.author_name}
                    </span>
                  )}
                  {blog.category && (
                    <span className="meta-item">
                      <i className="fas fa-tag"></i>
                      {blog.category}
                    </span>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          {/* First Image and Description Section */}
          {blog.title1_image && (
            <Row className="mb-5">
              <Col lg={10} className="mx-auto">
                <div className="blog-image-section">
                  <Image
                    src={blog.title1_image}
                    alt={blog.title1}
                    width="100%"
                    height={300}
                    style={{ objectFit: 'cover', borderRadius: 12 }}
                    className="shadow-sm"
                    loading="lazy"                  />
                </div>
              </Col>
            </Row>
          )}

          {/* Short Description */}
          {blog.short_description && (
            <Row className="mb-5">
              <Col lg={10} className="mx-auto">
                <p className="blog-short-desc">{blog.short_description}</p>
              </Col>
            </Row>
          )}

          {/* Long Description (Title1) */}
          {blog.title1_long_description && (
            <Row className="mb-5">
              <Col lg={10} className="mx-auto">
                <div className="blog-long-content">
                  <h2 className="section-title">{blog.title1 || "Overview"}</h2>
                  <p className="section-text">
                    {blog.title1_long_description}
                  </p>
                </div>
              </Col>
            </Row>
          )}

          {/* Second Section: Title2 and Description2 */}
          {(blog.title2 || blog.description2) && (
            <Row className="mb-5">
              <Col lg={10} className="mx-auto">
                <div className="blog-second-section">
                  {blog.title2 && (
                    <h2 className="section-title">{blog.title2}</h2>
                  )}
                  {blog.description2 && (
                    <p className="section-text">{blog.description2}</p>
                  )}
                </div>
              </Col>
            </Row>
          )}

          {/* Second Image */}
          {blog.title2_image && (
            <Row className="mb-5">
              <Col lg={10} className="mx-auto">
                <div className="blog-image-section">
                  <Image
                    src={blog.title2_image}
                    alt={blog.title2 || "Section Image"}
            width="100%"
            height={300}
            style={{ objectFit: 'cover', borderRadius: 12 }}
            className="shadow-sm"
            loading="lazy"
          />                  
                </div>
              </Col>
            </Row>
          )}

          {/* Back Button */}
          <Row className="mt-5">
            <Col lg={10} className="mx-auto text-center">
              <Button
                onClick={() => navigate("/blogs1")}
                className="btn-custom"
              >
                Back to Blogs
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </PageWrapper>
  );
};

export default Blogs2;
